<template>
  <div>
    <a-row :gutter="24" style="margin: 2vh 0;">
      <a-col :md="12" :sm="24" style="margin-bottom: 2vh;">
        <a-input-search placeholder="输入文件名进行搜索" enterButton/>
      </a-col>
      <a-col :md="8" :sm="24">
        <a-button type="primary" @click="visible = true" style="margin-right: 1vh;">上传图片</a-button>
        <a-button type="danger">批量删除</a-button>
      </a-col>
    </a-row>

    <a-table
      :rowSelection="rowSelection"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      :loading="loading">
      <template slot="name" slot-scope="text, record">
        <router-link to="#">{{ record.filename }}</router-link>
      </template>
      <template slot="md5" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            {{ text }}
          </template>
          {{ text.length>7?text.substring(0,7)+'...':text }}
        </a-tooltip>
      </template>
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="download(record)">下载</a>
      </span>
    </a-table>

    <a-modal
      :visible="visible"
      :okButtonProps="{ props: {disabled: false} }"
      title="上传图片">
      <template slot="footer">
        <a-button key="back" @click="visible = false">取消</a-button>
        <a-button
          type="primary"
          @click="handleUpload"
          :disabled="fileList.length === 0"
          :loading="uploading"
          icon="upload"
          style="margin-top: 2vh;">
          {{ uploading ? '正在上传...' : '开始上传' }}
        </a-button>
      </template>
      <a-upload-dragger
        name="file"
        :fileList="fileList"
        :beforeUpload="beforeUpload"
        :multiple="true"
        action="//jsonplaceholder.typicode.com/posts/"
        @change="handleChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或拖拽图片到此处</p>
        <p class="ant-upload-hint">Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files</p>
      </a-upload-dragger>
    </a-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      visible: false,
      uploading: false,
      fileList: [],
      columns: [
        {
          title: '文件名',
          dataIndex: 'filename',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: 'MD5',
          dataIndex: 'md5',
          scopedSlots: { customRender: 'md5' }
        },
        {
          title: '大小',
          dataIndex: 'size'
        },
        {
          title: '对应机芯',
          dataIndex: 'core'
        },
        {
          title: '备注',
          dataIndex: 'note'
        },
        {
          title: '上传时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '最近使用',
          dataIndex: 'lastUse'
        },
        {
          title: '操作',
          dataIndex: 'action',
          // width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      page: {
        content: [{
          id: '1',
          filename: '2019022001.pkg',
          md5: '926cc51f26997e7313c1d81456230968',
          size: '56.18MB',
          core: '5507',
          soft: '...MT5507_V9.00029',
          note: '5507升级-18年第五版',
          creatorName: '管理员',
          gmtCreate: '2018-12-08 10:31:55',
          lastUse: '酒店电视 2578 等5台终端'
        }, {
          id: '2',
          filename: '多媒体广告发布系统1007A.pkg',
          md5: '6d6730eee30715cb3faa5c7cf8e5a6c7',
          size: '72.31MB',
          core: '5507',
          soft: '...MT5507_V9.00029',
          note: '-',
          creator: '管理员',
          gmtCreate: '2018-12-24 12:00:02',
          lastUse: '无'
        }, {
          id: '3',
          filename: 'e30715cb3faa5c7c.pkg',
          md5: 'a39aa711dae09647997a234a39017e6d',
          size: '101.0MB',
          core: 'V551',
          soft: '...MT5507_V9.00029',
          note: 'V551 旧固件存档',
          creator: '管理员',
          gmtCreate: '2019-01-02 17:13:40',
          lastUse: '酒店电视 2580 等1台终端'
        }],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      }
    }
  },

  computed: {
    rowSelection () {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
        }
      }
    }
  },

  methods: {
    download (record) {
    },

    beforeUpload (file) {
      this.fileList = [...this.fileList, file]
      return false
    },

    handleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },

    handleUpload () {
      this.uploading = true

      this.fileList = []
      this.uploading = false
      this.$message.success('upload successfully.')
      this.visible = false
    }
  }
}
</script>

<style scoped>
  .upload-list-inline {
    margin-bottom: 2vh;
  }
  .upload-list-inline >>> .ant-upload-list-item {
    float: left;
    width: 200px;
    margin-right: 8px;
  }
  .upload-list-inline >>> .ant-upload-animate-enter {
    animation-name: uploadAnimateInlineIn;
  }
  .upload-list-inline >>> .ant-upload-animate-leave {
    animation-name: uploadAnimateInlineOut;
  }
</style>
